import api from '@/services/api';

import { load, load_close } from '@/services/load';
import { rootAuth_remove } from '@/storages/auth';

// BEFOREEACH
    export function beforeEach(to, form, next){
        load(1);

        response(to, form, next);
    }


    // MIDDLEWARE -> apijs (401 (Unauthorized))
    const response = async (to, form, next) => {
        var request = {};

        // $_GET
            $_GET = {};
            for(let key in to.query){
                $_GET[key] = to.query[key];
            }
        // $_GET


        // LOGOUT
            if(to.params.pg == `login` && to.params.get_1 == `logout`){
                await api(`/login/logout`);
                rootAuth_remove();
            }
        // LOGOUT


        // REQUEST
            let $pg = ``;

            // ?PG=
                if(to.href.split(`?pg=`)[1] != undefined){
                    let $ex = to.href.split(`?pg=`)[1];
                    let $ex_1 = $ex.split(`/`);
                    to.params.pg = $pg = $ex_1[0];
                    if($ex_1?.[1]!=undefined) to.params.get_1 = $ex_1[1];
                    if($ex_1?.[2]!=undefined) to.params.get_1 = $ex_1[2];
                    if($ex_1?.[3]!=undefined) to.params.get_1 = $ex_1[3];
                    if($ex_1?.[4]!=undefined) to.params.get_1 = $ex_1[4];
                }
            // ?PG=

            // HOME
                else if(to.name == `home` || to.params.pg == `index.html`){
                    $pg = `home`;
                    to.params.pg = $pg;

                    next({ path: '/dashboard/', replace: true });
                    return;
                }
            // HOME

            // DASHBOARD
                else if(to.path == `/dashboard`){
                    $pg = `dashboard`;
                    to.params.pg = $pg;
                }
                else if(to.path.split(`/dashboard/`)[1] != undefined){
                    if(to.params.get_1){
                        $pg = `dashboard/${to.params.get_1}`;
                    } else {
                        $pg = `dashboard`;
                    }
                    to.params.pg = $pg;
                }
            // DASHBOARD

            // OTHER
                else if(to.params.pg) {
                    $pg = to.params.pg;
                }
            // OTHER


            if(!$pg){
                next({ path: '/error404', replace: true });
                return;

            } else {
                let get_1 = (to.params.get_1!=undefined && to.path.split(`/dashboard`)[1]==undefined) ? `/${to.params.get_1}` : ``;
                let get_2 = to.params.get_2!=undefined ? `/${to.params.get_2}` : ``;
                let get_3 = to.params.get_3!=undefined ? `/${to.params.get_3}` : ``;
                let get_4 = to.params.get_4!=undefined ? `/${to.params.get_4}` : ``;
               
                Object.assign(request, await api(`/${$pg}_index${get_1}${get_2}${get_3}${get_4}`, to.params));
            }
        // REQUEST


        // NEXT
            // PARAMS REQUEST
                if(request){
                    to.params['request'] = request;
                }
            // PARAMS REQUEST

            next(true);
        // NEXT

    }
// BEFOREEACH


// AFTEREACH
    export function afterEach(to, form){
        load_close();
    }
// AFTEREACH
